// This file is generated, do not edit!
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { type Erzeuger } from "../../api";
import { useGetApi } from "../client";
import { useCallback } from "react";

export function useDeleteErzeuger(): (erzeugerId: string) => Promise<Erzeuger> {
  const getAPI = useGetApi();
  return useCallback(
    async (erzeugerId) =>
      (await getAPI()).erzeuger.deleteErzeuger({ erzeugerId }),
    [getAPI]
  );
}
